import { TextField } from '../../../components/TextField';
import { Button } from '../../../components/Button';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  CreatePopUpTargetBranchDto,
  UpdatePopUpTargetBranchDto,
} from '../../../types/popupTargetBranch';
import {
  getPopUpTargetBranch,
  patchPopUpTargetBranch,
  postPopUpTargetBranch,
} from '../../../api/popupTargetBranchAPI';

export interface PopUpTargetBranchTemplateProps {
  type: 'ADD' | 'EDIT';
  targetId?: number;
}

const PopUpTargetBranchTemplate = (props: PopUpTargetBranchTemplateProps) => {
  const { type, targetId } = props;
  const { goBack } = useHistory();
  const form = useForm<
    CreatePopUpTargetBranchDto | UpdatePopUpTargetBranchDto
  >();

  const onSubmit = async (data: CreatePopUpTargetBranchDto) => {
    if (type === 'ADD') {
      postPopUpTargetBranch(data)
        .then(() => goBack())
        .catch((err) => console.error(err.response));
    } else {
      patchPopUpTargetBranch(targetId!, data)
        .then(() => goBack())
        .catch((err) => console.error(err.response));
    }
  };

  useEffect(() => {
    targetId &&
      getPopUpTargetBranch(targetId)
        .then((res) => {
          form.setValue('branchName', res.data.branchName);
        })
        .catch((err) => console.error(err.response));
  }, [targetId]);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="max-w-md space-y-4">
        <TextField
          label="지점명"
          {...form.register('branchName', { required: true })}
        />

        {type === 'ADD' ? (
          <>
            <Button
              type={'submit'}
              text="추가하기"
              className="filled-black h-12 w-full px-6"
            />
            <Button
              type={'button'}
              text="취소"
              className="outlined-black h-12 w-full px-6"
              onClick={() => goBack()}
            />
          </>
        ) : (
          <>
            <Button
              type={'submit'}
              text="저장하기"
              className="filled-black h-12 w-full px-6"
            />
          </>
        )}
      </div>
    </form>
  );
};

export default PopUpTargetBranchTemplate;
